import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { getAppAuth } from '../../api/axios.instance';
import { Consent } from '../../modules/oauth-consent';
import { CenteredLayout } from '../../ui/components/layout';
import { hideHtmlLoader } from '../../ui/utils/html';

const OauthConsentSearchSchema = z.object({
  interaction: z.string(),
});

export const Route = createFileRoute('/oauth/consent')({
  validateSearch: OauthConsentSearchSchema,
  beforeLoad: ({ location }) => {
    hideHtmlLoader();

    if (!getAppAuth().currentUser) {
      throw redirect({ to: '/auth/signin', search: { redirectTo: location.href } });
    }
  },
  component: OauthConsentRoute,
});

function OauthConsentRoute() {
  const { interaction } = Route.useSearch();

  return (
    <CenteredLayout>
      <Consent interactionUid={interaction} />
    </CenteredLayout>
  );
}
